<template>
  <v-layout row>
    <v-container
      fluid
      grid-list-sm
      id="scroll-target"
      style="max-height: 90vh; height: 90vh"
      class="scroll-y"
      pa-0
    >
      <v-flex xs12 sm12>
        <v-card color="#000000">
          <v-toolbar prominent flat color="blue" class="text-sm-left" dark>
            <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

            <!-- <v-toolbar-title class="white--text pl-0"> -->
            <v-layout align-center justify-center row fill-height>
              <h3 class="pr-2">Leads</h3>
              <v-spacer />
              <v-badge color="red" class="mt-3 mr-5 pr-0">
                <template v-slot:badge>
                  <span>{{ leads ? leads.length : 0 }}</span>
                </template>
                <v-icon color="white" larger> people </v-icon>
              </v-badge>
            </v-layout>
            <!-- </v-toolbar-title> -->

            <!-- <v-spacer></v-spacer> -->

            <!-- <v-btn icon>
                <v-icon @click="activeSearch">search</v-icon>
            </v-btn> -->

            <!-- <v-btn icon>
                <v-icon>filter_alt</v-icon>
            </v-btn> -->
          </v-toolbar>
          <v-text-field
            class="mx-3"
            flat
            label="Buscar"
            prepend-inner-icon="search"
            solo-inverted
            v-model="search"
            clearable
            @click:clear="clearSearch"
          ></v-text-field>

          <v-list three-line>
            <template v-for="(item, index) in filteredItems">
              <v-list-tile
                :key="item.id"
                avatar
                ripple
                @click="toggle(index, item)"
              >
                <v-list-tile-content>
                  <v-list-tile-sub-title class="grey--text text--lighten-1">{{
                    item.updated_at | formatarDateTime
                  }}</v-list-tile-sub-title>
                  <v-list-tile-title>
                    {{ item.email }}
                  </v-list-tile-title>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">
                    <v-avatar
                      ><v-icon color="blue">{{
                        item.person_type && item.person_type === "pj"
                          ? "business"
                          : "person"
                      }}</v-icon></v-avatar
                    >
                    <v-chip
                      :text-color="formatChannel(item.channel).text_color"
                      small
                      :color="formatChannel(item.channel).color"
                    >
                      <v-avatar
                        v-if="formatChannel(item.channel).icon !== ''"
                        :color="formatChannel(item.channel).color"
                      >
                        <v-icon
                          small
                          :color="formatChannel(item.channel).text_color"
                          >{{ formatChannel(item.channel).icon }}</v-icon
                        >
                      </v-avatar>
                      {{ formatChannel(item.channel).text }}
                    </v-chip>

                    <v-chip small color="yellow">{{
                      item.utility ? item.utility.toUpperCase() : "cemig"
                    }}</v-chip>
                  </v-list-tile-sub-title>
                  <!-- <v-list-tile-sub-title><v-chip dark small>{{ item.person_type }}</v-chip></v-list-tile-sub-title> -->
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-list-tile-action-text>{{
                    item.action
                  }}</v-list-tile-action-text>

                  <v-icon color="grey darken-2"> front_hand </v-icon>
                  <!-- <v-icon
                    v-if="selected.indexOf(index) < 0"
                    color="grey lighten-1"
                    >
                    front_hand
                    </v-icon>

                    <v-icon
                    v-else
                    color="yellow darken-2"
                    >
                    front_hand
                    </v-icon> -->
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < leads.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-container>
    <!-- <create-member/> -->
  </v-layout>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import { eventBus } from "../../main";
import { getUser, getUserByEmail } from "../../services/users";
import _ from "lodash";
export default {
  data() {
    return {
      selected: [2],
      search: "",
    };
  },
  computed: {
    ...mapState("sales", ["leads"]),
    filteredItems() {
      return _.orderBy(
        this.leads.filter((item) => {
          if (!this.search) return this.leads;
          return (
            (item.name &&
              item.name.toLowerCase().includes(this.search.toLowerCase())) ||
            (item.email &&
              item.email.toLowerCase().includes(this.search.toLowerCase())) ||
            (item.person_type &&
              item.person_type
                .toLowerCase()
                .includes(this.search.toLowerCase())) ||
            (item.channel &&
              item.channel.toLowerCase().includes(this.search.toLowerCase()))
          );
        }),
        "headline",
      );
    },
  },
  mounted() {
    if (!this.leads || this.leads.length <= 0) {
      let params = {
        start_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      };
      this.getLeads(params);
      // this.getLeads()
    }
  },
  methods: {
    ...mapActions("sales", ["getLeads"]),
    clearSearch() {
      this.search = "";
    },
    async toggle(index, item) {
      console.log("item: ", item);
      const i = this.selected.indexOf(index);

      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        this.selected.push(index);
      }
      let user = null;
      if (item.customer_id) {
        let _user = await getUser(item.customer_id);
        if (_user.exists) user = { id: _user.id, ..._user.data() };
      } else {
        console.log("email: ", item.email);
        let _user = await getUserByEmail(item.email);
        if (_user.size > 0)
          user = { id: _user.docs[0].id, ..._user.docs[0].data() };
        console.log("_user: ", _user);
        console.log("user: ", user);
      }
      if (user != null) item.user = user;
      eventBus.$emit("Lead", item);
    },
    formatChannel(channel) {
      if (!channel || channel === "")
        return {
          text: "",
          color: "#c0c0c0",
          icon: "",
        };
      if (channel === "mobile_app")
        return {
          text: "App",
          color: "blue",
          icon: "phone_android",
          text_color: "#FFF",
        };
      else if (channel === "lead_ads")
        return {
          text: "Facebook",
          color: "#800000",
          icon: "",
          text_color: "#FFF",
        };
      else if (channel === "web")
        return {
          text: "Web",
          color: "teal",
          icon: "language",
          text_color: "#FFF",
        };
    },
  },
  async open(lead) {
    console.log("lead: ", lead);
    let user = null;
    if (lead.customer_id) {
      let _user = await getUser(lead.customer_id);
      if (_user.exists) user = { id: user.id, ...user.data() };
    } else {
      let _user = await getUserByEmail(lead.customer_id);
      if (_user.size > 0)
        user = { id: user.docs[0].id, ...user.docs[0].data() };
    }
    if (user != null) lead.user = user;
    eventBus.$emit("Lead", lead);
  },
};
</script>
